<template>
  <div class="main-wrapper">
    <v-app-bar
      class="header-bar"
      max-height="4rem"
      clipped-left
      clipped-right
      app
      flat
    >
      <div class="header-content">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          class="btn-icon"
          icon
          @click.stop="handleDrawer()"
        >
          <v-icon>
            {{ drawer ? "mdi-menu-open" : "mdi-menu-close" }}
          </v-icon>
        </v-btn>

        <router-link
          v-if="$vuetify.breakpoint.mdAndUp"
          class="d-flex justify-center align-center text-decoration-none mr-4"
          :to="{ name: 'Home' }"
        >
          <v-avatar color="neutral3">
            <v-img
              :src="$settings?.profile?.logo"
              max-width="1.75rem"
              height="1.75rem"
              contain
            />
          </v-avatar>
        </router-link>

        <div
          v-if="$vuetify.breakpoint.mdAndUp && _currentRaffle"
          class="relative pointer"
          @click="handleOpenStore()"
        >
          <v-img
            :src="require('@/assets/main/fire-flame.gif')"
            class="floating-flame"
            max-width="2rem"
            height="3rem"
          >
            <v-icon class="rocket-icon" color="white" small>
              fa-solid fa-rocket
            </v-icon>
          </v-img>

          <v-chip
            v-if="$vuetify.breakpoint.smAndUp && _currentRaffle"
            class="pl-10 pointer"
            color="neutral4"
            exact-path
          >
            <div class="font-weight-bold text-caption">
              <span>
                {{ $vuetify.breakpoint.smAndUp ? "AUMENTE SUAS " : "+" }}
              </span>

              <span class="primary--text">CHANCES</span>
            </div>
          </v-chip>
        </div>

        <v-menu content-class="mt-2" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-img
              v-bind="attrs"
              v-on="on"
              :src="`https://flagsapi.com/${$store.getters.language.flag}/flat/64.png`"
              class="ml-2 pointer"
              max-width="1.75rem"
              contain
            />
          </template>

          <v-card class="card rounded-lg pa-2" color="neutral4">
            <v-list class="transparent pa-0" nav dense>
              <v-list-item
                v-for="(item, i) in languages"
                :key="i"
                link
                @click="$store.commit('SET_LANGUAGE', item)"
              >
                <v-list-item-icon class="mr-4">
                  <v-img
                    :src="`https://flagsapi.com/${item.flag}/flat/64.png`"
                    max-width="2rem"
                    contain
                  />
                </v-list-item-icon>

                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-spacer />

        <div class="d-flex flex-column flex-md-row text-right">
          <v-tooltip color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="currency-chip neutral4 rounded-xl pointer pl-2 mr-2 mb-1 mb-md-0"
                @click.stop.prevent="openWallet()"
              >
                <span class="font-weight-bold text-caption text-md-body-2 mr-1">
                  <span class="currencyColor--text">R$</span>
                  {{ currencyMask(_user?.wallet?.balance) }}
                </span>

                <v-icon color="primary" small> fas fa-plus-circle </v-icon>
              </div>
            </template>

            <span>Saldo da sua conta</span>
          </v-tooltip>

          <v-tooltip color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="currency-chip neutral4 rounded-xl pointer pl-3 pr-1 mr-2"
                @click.stop.prevent="openItemShop()"
              >
                <span class="font-weight-bold text-caption text-md-body-2 mr-1">
                  {{ _user?.profile?.points }}
                </span>

                <v-icon color="pointColor" small>mdi-cards-diamond </v-icon>
              </div>
            </template>

            <span>Pontos disponíveis</span>
          </v-tooltip>
        </div>

        <router-link class="mr-2" :to="{ name: 'General' }">
          <v-tooltip color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                class="mb-1 font-weight-bold"
                color="neutral4"
                small
                label
              >
                Nível {{ _user?.profile?.level || 1 }}
              </v-chip>
            </template>

            <span>Nível atual da sua conta</span>
          </v-tooltip>

          <v-tooltip color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-progress-linear
                v-bind="attrs"
                v-on="on"
                :value="_xpPercentage"
                class="rounded-xl"
                height="8"
                color="light-blue accent-4"
                background-color="neutral4"
                striped
              ></v-progress-linear>
            </template>

            <span>
              Experiência: {{ _user?.profile?.xp }} /
              {{ _user?.profile?.xp + _user?.profile?.xpToLevelUp }}
            </span>
          </v-tooltip>
        </router-link>

        <v-tooltip color="black" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-badge
                color="red"
                offset-x="24"
                offset-y="14"
                :value="_user?.inventory?.items?.length > 0"
                :content="_user?.inventory?.items?.length"
              >
                <v-btn
                  class="mr-2 neutral4"
                  width="2.5rem"
                  height="2.5rem"
                  icon
                  @click="handleOpenInventory()"
                >
                  <v-img
                    :src="require('@/assets/main/bag-icon.svg')"
                    class="bag-icon"
                    max-width="1.5rem"
                    contain
                  />
                </v-btn>
              </v-badge>
            </div>
          </template>

          <span> Seu inventário de itens </span>
        </v-tooltip>

        <v-avatar
          class="cursor-pointer mr-2"
          color="primary"
          size="2.5rem"
          @click="$router.push({ name: 'Profile' })"
        >
          <v-avatar class="pointer" color="neutral2" size="2.375rem">
            <v-img v-if="_user.photo" :src="_user.photo" />
            <v-icon v-else color="neutral6" small>fas fa-user</v-icon>
          </v-avatar>
        </v-avatar>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="side-drawer pa-md-0"
      color="neutral2"
      clipped
      floating
      app
    >
      <div class="overflow-y-auto drawer-content">
        <div class="d-flex flex-column pt-3 pb-8">
          <div
            v-if="$vuetify.breakpoint.mdAndDown"
            class="d-flex justify-center mb-2 mb-md-4"
          >
            <v-img
              :src="$settings?.profile?.logo"
              class="mr-2"
              max-width="2rem"
              height="2rem"
              contain
            />

            <span class="text-h6"> {{ _title }} </span>
          </div>

          <v-list class="px-6" color="transparent" dense nav>
            <router-link
              v-for="(item, i) in _routes"
              v-show="!item.hide"
              v-slot="{ href, navigate, isActive }"
              :to="item.path"
              :key="i"
              class="relative"
              custom
            >
              <div>
                <v-sheet
                  v-if="isActive"
                  class="item-flag absolute"
                  color="primary"
                  width="0.25rem"
                  height="1.625rem"
                ></v-sheet>

                <v-list-item
                  class="mb-1 rounded-xl pl-4 pr-2"
                  :class="{
                    'active-route-item': isActive,
                    transparence: item.disabled,
                  }"
                  :href="href"
                  :disabled="item.disabled"
                  @click="navigate"
                >
                  <v-list-item-icon class="mr-2" size="1.75rem">
                    <v-icon :color="isActive ? 'primary' : 'neutral8'" small>
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-title
                    :class="{
                      'text1--text': isActive,
                      'neutral8--text': !isActive,
                    }"
                  >
                    {{ item.label }}
                  </v-list-item-title>

                  <v-list-item-action v-if="item.new" class="ml-1">
                    <v-chip class="px-0" color="red" x-small label>
                      <span class="font-weight-bold"> New </span>
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </router-link>
          </v-list>

          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-divider class="neutral4 mb-4 mx-6" />

            <v-card
              class="card px-4 py-2 mb-4 wpp-border rounded-lg mx-6"
              target="_blank"
              :href="_whatsappURL"
            >
              <div class="d-flex align-center">
                <v-icon color="green accent-4" left>fab fa-whatsapp</v-icon>

                <div class="green--text text--accent-4 text-body-2">
                  Grupo do Whats
                </div>
              </div>
            </v-card>
          </template>

          <v-divider class="neutral4 mb-4 mx-6" />

          <div class="px-10">
            <div class="d-flex align-center mb-2">
              <v-icon color="blue" left x-small> fas fa-info-circle </v-icon>

              <div class="text-body-2 neutral9--text font-weight-bold">
                Outras informações
              </div>
            </div>

            <div class="d-flex flex-column text-body-2">
              <router-link
                v-for="(item, i) in _otherRoutes"
                :key="i"
                :to="item.path"
                class="information-link neutral8--text text-decoration-none mb-2"
                active-class="text1--text font-weight-bold"
              >
                {{ item.label }}
              </router-link>
            </div>

            <div
              class="information-link neutral8--text text-decoration-none pointer mb-2"
              @click="signOut()"
            >
              Sair
            </div>

            <div class="text-caption neutral6--text">v{{ _appVersion }}</div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <DailyBonus v-if="_allowedRoutes" ref="dailyBonus" />

    <ConfirmEmail v-if="!_user?.emailConfirmed && _allowedRoutes" />

    <loader v-if="loading" color="neutral4" size="32" />

    <router-view v-else-if="_user" />

    <div
      v-if="$vuetify.breakpoint.smAndDown && _allowedRoutes && _currentRaffle"
      class="floating-store"
      @click="handleOpenStore()"
    >
      <div
        class="relative d-flex align-center pointer"
        @click="handleOpenStore()"
      >
        <v-img
          :src="require('@/assets/main/fire-flame.gif')"
          class="floating-flame"
          max-width="2rem"
          height="3rem"
        >
          <v-icon class="rocket-icon" color="white" small>
            fa-solid fa-rocket
          </v-icon>
        </v-img>

        <v-chip class="pl-10 pointer" color="neutral4" exact-path>
          <div class="font-weight-bold text-caption">
            <span>
              {{ $vuetify.breakpoint.smAndUp ? "AUMENTE SUAS " : "+" }}
            </span>

            <span class="primary--text">CHANCES</span>
          </div>
        </v-chip>
      </div>
    </div>

    <InstallApp v-if="$vuetify.breakpoint.smAndDown && _allowedRoutes" />

    <v-bottom-navigation
      v-if="
        $vuetify.breakpoint.smAndDown && _allowedRoutes && _navRoutes.length
      "
      background-color="neutral3"
      fixed
      app
    >
      <v-btn
        v-for="(item, i) in _navRoutes"
        class="mobile-btn"
        :key="i"
        :to="{ name: item.route }"
        @click.stop
      >
        <span class="mobile-btn-text mt-1" v-html="item.label" />

        <v-icon
          :color="item.route === $route.name ? 'primary' : 'neutral8'"
          small
        >
          {{ item.icon }}
        </v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      class="mb-n2 ml-n2"
      color="green accent-4"
      target="_blank"
      width="2.5rem"
      height="2.5rem"
      :href="_whatsappURL"
      depressed
      bottom
      left
      dark
      fixed
      fab
    >
      <v-icon>fab fa-whatsapp</v-icon>
    </v-btn>

    <BottomPopup v-model="storePopup" @close="storePopup = false">
      <v-row class="fill-height" justify="center" align="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="5">
          <BoosterShop @close="handleCloseStore()" />
        </v-col>
      </v-row>
    </BottomPopup>

    <News ref="news" />

    <PausedDraw ref="pausedDraw" />

    <InventorySide ref="inventorySide" />

    <RaffleStatusDialog ref="raffleStatusDialog" />

    <Tutorial ref="tutorial" @closed="handleCloseTutorial()" />

    <GiftDialog ref="giftDialog" />
  </div>
</template>

<script>
import { connect as connectSocket } from "@/socket";
import { initSocketWatcher } from "@/socket/watcher";
import { mapGetters, mapActions } from "vuex";
import { getGames, getGamesAvailable } from "@/services/games";
import { getRaffles, getRaffleID } from "@/services/raffles";
import { getRanking } from "@/services/ranking";
import { getMatches } from "@/services/matches";
import { currencyMask, currentDate } from "@/helpers";
import BottomPopup from "@/components/bottomPopup/BottomPopup.vue";
import InstallApp from "@/components/installApp/InstallApp.vue";
import ConfirmEmail from "./partials/confirmEmail/ConfirmEmail.vue";
import BoosterShop from "./partials/boosterShop/BoosterShop.vue";
import DailyBonus from "./partials/dailyBonus/DailyBonus";
import News from "./partials/news/News";
import PausedDraw from "./partials/pausedDraw/PausedDraw.vue";
import Tutorial from "./partials/tutorial/Tutorial";
import InventorySide from "./partials/inventorySide/InventorySide.vue";
import RaffleStatusDialog from "./partials/raffleStatusDialog/RaffleStatusDialog";
import GiftDialog from "./partials/giftDialog/GiftDialog";
import dayjs from "dayjs";

export default {
  name: "Main",

  components: {
    BottomPopup,
    InstallApp,
    BoosterShop,
    ConfirmEmail,
    DailyBonus,
    News,
    PausedDraw,
    Tutorial,
    InventorySide,
    RaffleStatusDialog,
    GiftDialog,
  },

  data() {
    return {
      loading: true,
      drawer: true,
      menuAvatar: false,
      storePopup: false,
      xpProgress: 1,
      level: 1,
      languages: [
        {
          flag: "BR",
          value: "PT",
          label: "Português",
        },
        {
          flag: "US",
          value: "EN",
          label: "Inglês",
        },
        {
          flag: "ES",
          value: "ES",
          label: "Espanhol",
        },
      ],
    };
  },

  created() {
    this.getData();
    this.initSocket();
  },

  beforeMount() {
    if (this.$vuetify.breakpoint.mdAndDown) this.drawer = false;

    this.$root.$on("open-store", this.handleOpenStore);
    this.$root.$on("open-inventory", this.handleOpenInventory);
    this.$root.$on("refresh:current-raffle", this.getOpenRaffle);
    this.$root.$on("refresh:game-eligibility", this.getGamesAvailable);
    this.$root.$on("paused-draw", this.handlePauseDialog);
  },

  mounted() {
    if (this.$route.query.shop) this.handleOpenStore();
    if (this.$route.query.firstAccess) this.$refs.tutorial.open();

    this.setCrispData();
    // this.handleNewsDialog();
  },

  beforeDestroy() {
    this.$root.$off("open-store", this.handleOpenStore);
    this.$root.$off("open-inventory", this.handleOpenInventory);
    this.$root.$off("refresh:current-raffle", this.getOpenRaffle);
    this.$root.$off("refresh:game-eligibility", this.getGamesAvailable);
    this.$root.$off("paused-draw", this.handlePauseDialog);

    this.destroySocket();
  },

  computed: {
    ...mapGetters({
      _user: "user",
      _currentRaffle: "currentRaffle",
    }),

    _title() {
      return process.env.VUE_APP_PROJECT_NAME;
    },

    _xpPercentage() {
      const xp = this._user?.profile?.xp;
      const toLevelUp = xp + this._user?.profile?.xpToLevelUp;

      return Math.min((xp / toLevelUp) * 100, 100);
    },

    _routes() {
      return [
        {
          icon: "fa-house",
          label: "Início",
          path: "/home",
        },
        ...(this.$features.raffles
          ? [
              {
                icon: "fa-crosshairs",
                label: "Todos os sorteios",
                path: "/raffles",
              },
              {
                icon: "fa-ticket",
                label: "Meus bilhetes",
                path: "/my-tickets",
              },
              {
                icon: "fa-trophy",
                label: "Ganhadores",
                path: "/winners",
              },
            ]
          : []),
        ...(this._currentRaffle && this.$features.raffles
          ? [
              {
                icon: "mdi-podium-gold",
                label: "Ranking Apoiadores",
                path: "/ranking",
              },
            ]
          : []),
        {
          icon: "fas fa-store",
          label: "Loja de Itens",
          path: "/item-shop",
          new: true,
        },
        /*  {
          icon: "mdi-progress-star",
          label: "Raspadinhas",
          path: "/scratchs",
          new: true,
        }, */
        {
          icon: "fa-user",
          label: "Meu Perfil",
          path: "/profile",
          new: true,
        },
        {
          icon: "fa-wallet",
          label: "Minha Carteira",
          path: "/wallet",
        },
        {
          icon: "fas fa-hands-helping",
          label: "Afiliados",
          path: "/affiliates",
        },
        {
          icon: "fas fa-bullhorn",
          label: "Patrocínio e propaganda",
          path: "/sponsor",
          hide: !this._user?.admin,
        },
      ];
    },

    _otherRoutes() {
      return [
        {
          label: "Sobre nós",
          path: "/about",
        },
        {
          label: "Termos e condições",
          path: "/terms",
        },
        {
          label: "Ajuda",
          path: "/help",
        },
      ];
    },

    _navRoutes() {
      if (!this.$features.raffles) return [];

      return [
        {
          icon: "fa-trophy",
          label: "Ganhadores",
          route: "Winners",
        },
        {
          icon: "fa-house",
          label: "Início",
          route: "Home",
        },
        {
          icon: "fa-ticket",
          label: "Meus Sorteios",
          route: "MyTickets",
        },
      ];
    },

    _name() {
      if (!this._user.name) return "";

      const firstWord = this._user.name.trim().split(" ")[0];

      return (
        firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase()
      );
    },

    _whatsappURL() {
      return this.$settings.profile?.whatsappGroup;
    },

    _allowedRoutes() {
      const locked = ["Games", "PrizeWord", "LuckyPath", "Hangman"];

      return !locked.includes(this.$route.name);
    },

    _appVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },

  methods: {
    ...mapActions([
      "setCurrentRaffle",
      "setGameEligibility",
      "setBonusEligible",
      "setGames",
    ]),

    async initSocket() {
      await connectSocket();
      initSocketWatcher();

      this.$socket.getSocket().on("raffles:status", this.handleRafflesStatus);
      this.$socket.getSocket().on("ranking:status", this.handleRankingStatus);
      this.$socket
        .getSocket()
        .on("promotions:rewarded", this.handleRewardedPromotion);
    },

    destroySocket() {
      this.$socket.getSocket().off("raffles:status", this.handleRafflesStatus);
      this.$socket.getSocket().off("ranking:status", this.handleRankingStatus);
      this.$socket
        .getSocket()
        .off("promotions:rewarded", this.handleRewardedPromotion);
    },

    async getData() {
      await this.getGames();

      await Promise.all([
        this.getOpenRaffle(),
        this.getGamesAvailable(),
        this.handleBonusEligibility(),
      ]);

      this.loading = false;
    },

    async getGames() {
      try {
        const payload = {
          sortBy: "position",
          sortOrder: "asc",
        };

        const { data } = await getGames(payload);

        this.setGames(
          data.map((el) => ({
            _id: el._id,
            value: el.gameType,
            gameMode: el.gameMode,
            eligible: true,
            new: el.new || false,
          }))
        );
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async getOpenRaffle() {
      if (!this.$features.raffles) return;

      try {
        const payload = {
          status: ["open"],
        };

        const { data } = await getRaffles(payload);

        if (!data?.length) {
          return;
        }

        this.setCurrentRaffle(data[0]);
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async getRaffleID(raffleID) {
      try {
        const { data } = await getRaffleID(raffleID);

        return data;
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async getRanking() {
      try {
        const today = currentDate("YYYY-MM-DDT00:00:00-03:00");

        const yesterday = dayjs(today)
          .subtract(1, "day")
          .format("YYYY-MM-DDT00:00:00-03:00");

        const payload = {
          date: yesterday,
          type: "tickets",
        };

        const { data } = await getRanking(payload);

        if (!data.length) return null;

        return data[0];
      } catch (error) {
        this.$alert(error?.message, "error");
        return null;
      }
    },

    async handleBonusEligibility() {
      if (!this.$features.raffles || !this._currentRaffle) return;

      try {
        const payload = {
          personIDs: [this._user?._id],
          raffleIDs: [this._currentRaffle?._id],
        };

        const { data } = await getMatches(payload);

        if (!data?.length) return;

        this.setBonusEligible(
          !!data.find(
            (el) => el.gived && this._currentRaffle?.status === "open"
          )
        );
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async getGamesAvailable() {
      try {
        const { data } = await getGamesAvailable();

        data.forEach((el) => {
          this.setGameEligibility({
            game: el.gameType,
            value: el.available,
          });
        });
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async handleRafflesStatus(event) {
      const raffle = await this.getRaffleID(event.raffleID, event.status);

      let ranking = null;

      if (event.status === "finished" && raffle)
        ranking = await this.getRanking();

      if (event.status === "opening" || event.status === "open") {
        this.setCurrentRaffle(raffle);
        this.handleEligibility();
      }

      this.$refs.raffleStatusDialog.open(raffle, ranking);
    },

    async handleRankingStatus(event) {
      this.$refs.raffleStatusDialog.setRanking(event);
    },

    handleNewsDialog() {
      let news = JSON.parse(
        sessionStorage.getItem("news:gamefication") || "[]"
      );

      if (!news.includes("news:gamefication")) {
        this.$refs.news.open();
        news.push("news:gamefication");
        sessionStorage.setItem("news:gamefication", JSON.stringify(news));
      }
    },

    handleOpenInventory() {
      this.$refs.inventorySide.open();
    },

    openWallet() {
      this.$router.push(
        { name: "Wallet", query: { redirect: "deposit" } },
        () => {},
        () => {}
      );
    },

    openItemShop() {
      this.$router.push(
        { name: "ItemShop" },
        () => {},
        () => {}
      );
    },

    handleOpenStore() {
      this.storePopup = true;
    },

    handleCloseStore() {
      this.storePopup = false;
    },

    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$root.$emit("sign-out");
    },

    setCrispData() {
      if (
        this._user &&
        window.$crisp &&
        process.env.VUE_APP_ENV === "production"
      ) {
        window.$crisp.push(["set", "user:email", [this._user.email]]);
        window.$crisp.push(["set", "user:nickname", [this._user.name]]);
        window.$crisp.push([
          "set",
          "user:phone",
          [`+55${this._user.phone.replace(/\D/g, "")}`],
        ]);
        window.$crisp.push([
          "set",
          "session:data",
          [[["usuario_id", this._user._id]]],
        ]);
        if (this._user?.photo)
          window.$crisp.push(["set", "user:avatar", [this._user?.photo]]);
      }
    },

    handleCloseTutorial() {
      const query = { ...this.$route.query };
      delete query.firstAccess;

      this.$router.replace(
        { query },
        () => {},
        () => {}
      );
    },

    handleRewardedPromotion(event) {
      if (!event.rewards.length) return;

      this.$root.$emit("load-session");
      this.$refs.giftDialog.open(event.rewards);
    },

    handlePauseDialog() {
      this.$refs.pausedDraw.open();
    },

    currencyMask,
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
